import {remCalc} from '_themeUtils'

const helpBox = {
    HelpBox: {
        baseStyle: () => ({
            helpBox: {
                background: 'color.background.grey.200',
                mx: {base: remCalc(-16), md: remCalc(-24), lg: 0}, // Negative margin is for the box custom layout
                pt: 'spacing.8',
                px: 'spacing.6',
                pb: 'spacing.6',
            },
            title: {
                textTransform: 'uppercase',
                textStyle: 'paragraphSm',
                color: 'color.text.grey.500',
                letterSpacing: remCalc(3),
                mb: 'spacing.4',
            },
            subtitle: {
                textStyle: 'paragraphSm',
                letterSpacing: remCalc(3),
                fontWeight: 400,
                mb: 'spacing.4',
            },
            description: {
                textDecoration: 'underline',
                textStyle: 'paragraphXs',
                mb: 'spacing.8',
                letterSpacing: remCalc(3),
            },
            buttons: {
                spacing: 'spacing.4',
            },
            button: {
                w: 'fit-content',
                spacing: 'spacing.4',
            },
            buttonText: {
                textStyle: 'paragraphXs',
                textDecoration: 'underline',
                letterSpacing: remCalc(3),
            },
        }),
    },
}

export default helpBox
